export const tournamentCalendar = {
	catchMessage: "There was an error loading tournaments, please try again.",
	noResultsRangeMessage: "There are no tournaments on this week. Please select another date range.",
	noResultsMessage: "There are no results for your search."
};

export const tournamentAcceptanceList = {
	catchMessage: "There was an error loading the acceptance lists, please try again."
};

export const tennisTech = {
	surfacesCatchMessage: "There was an error loading Classified Surfaces, please try again.",
	ballsCatchMessage: "There was an error loading Approved Balls, please try again."
};

export const tournamentOOP = {
	catchMessage: "Sorry, the order of play could not be loaded at this time. Please try again.",
	noInfo: "No information will be displayed here until the order of play for this tournament is released. Please come back again soon."
};

export const tournamentDraws = {
	catchMessage: "Sorry, the drawsheets could not be loaded at this time. Please try again.",
	noInfo: "No information will be displayed here until the draws for this tournament are released. Please come back again soon."
};

export const playerProfile = {
	points: "error",
	rankings: "error",
	slams: "error",
	titles: "error",
	overview: "error",
	activity: "error",
	search: "The selected player could not be found"
};

export const playerSearch = {
	noResultsMessage: "The selected player could not be found"
};

export const associations = {
	generalError: "There was an error loading national and regional associations, please try again.",
	specificError: "There was an error loading the chosen Association, please try again."
};

export const headToHead = {
	noPlayers: "No players could be found. Please try again later."
};

export const articleList = {
	catchMessage: "Sorry, your request could not be loaded at this time. Please try again.",
	noResultsMessage: "No results were found"
};

export const tournaments = {
	noResults: "There are no results for your selection"
};
